import React from "react";
import "./Operations.css";

const Calendar = () => (
  <section className="ops-page">
    <div className="ops-calendar">
      <article className="ops-calendar__hero"><i className="far fa-calendar-alt" /><h2>Kalender operasional sedang disiapkan</h2><p>Halaman ini telah diselaraskan dengan SPIN Management Portal. Saat jadwal operasional tersedia dari API, agenda settlement, payout, dan rekonsiliasi dapat ditampilkan tanpa mengubah navigasi.</p></article>
      <aside className="ops-calendar__aside"><h3>Rencana informasi kalender</h3><div><i className="fas fa-money-check-alt" /><span><strong>Jadwal settlement</strong><small>Periode pencairan dari payment gateway.</small></span></div><div><i className="fas fa-hand-holding-usd" /><span><strong>Batch payout merchant</strong><small>Agenda pemeriksaan dan persetujuan payout.</small></span></div><div><i className="fas fa-balance-scale" /><span><strong>Rekonsiliasi transaksi</strong><small>Pengingat pemeriksaan laporan keuangan.</small></span></div></aside>
    </div>
  </section>
);

export default Calendar;
